export default __webpack_public_path__ + "static/media/article07.462edcd9.md";